import send from './send';
import { eventsKeys } from '../constants';

export default () => {
  send(eventsKeys.CLICK_DOWNLOAD_AND_SHARE_ON_MINISITE);
};
